module.exports = __webpack_public_path__ + "static/media/S4P1_screening-implications.0dc9153b.mp3";